(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 45728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(61878);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 57922:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/blurred-background.01a1e933.jpg","height":1080,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAABBQACAwAAAAAAAAAAAAABAAIDBBEFExQhUf/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAGBEAAgMAAAAAAAAAAAAAAAAAAAECESL/2gAMAwEAAhEDEQA/AJLOSvWfMgN2y2SO3MDJ2nHjBgLRg9fUREKLwWT/2Q==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 48443:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/commercial.0713c918.jpg","height":370,"width":700,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAACAgEFAAAAAAAAAAAAAAABAwACERQhIjFx/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/EABYRAQEBAAAAAAAAAAAAAAAAAAABMf/aAAwDAQACEQMRAD8ApbvdqXKDmCtTQjFztx68iIhKY//Z","blurWidth":8,"blurHeight":4});

/***/ }),

/***/ 22396:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/affirm-dark.99e1094d.png","height":36,"width":90,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAALVBMVEUAMDAAGyoPr/sAFSIADxgAFyQPsv8LerMABAgAIjUAGioSqvUAChIISm0HRmb/Qar+AAAAD3RSTlMCYjhzL5pPgD13hRt+e0i270SIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVR4nGNgYGDgZmNiY2JgYWTl5WPhYGdg5WJkZubkYQcABgYAhr+eOjQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 61878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_components_category_Reviews__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61874);
/* harmony import */ var _src_components_category_WhyBulletPoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65727);
/* harmony import */ var _src_static_images_landing_blurred_background_jpg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57922);
/* harmony import */ var _src_static_images_landing_commercial_jpg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48443);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var _src_static_images_logos_affirm_dark_png__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22396);
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(25631);
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96981);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _src_components_city_sections_WhyFeatures__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19103);













var VideoModalCommercial = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(Promise.all(/* import() */[__webpack_require__.e(5406), __webpack_require__.e(5732)]).then(__webpack_require__.bind(__webpack_require__, 75732)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75732)
            ];
        }
    }
});
var HomeCategories = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return __webpack_require__.e(/* import() */ 6511).then(__webpack_require__.bind(__webpack_require__, 56511));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56511)
            ];
        }
    }
});
var BrandsSection = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(8553)]).then(__webpack_require__.bind(__webpack_require__, 38553));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38553)
            ];
        }
    }
});

var HomePage = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)({
        isActive: false
    }), masterProvider = ref[0], setMasterProvider = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(true), showReviews = ref1[0], setShowReviews = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), showModalCommercial = ref2[0], setShowModalCommercial = ref2[1];
    var phoneNumber = "(800)228-8379"; // TODO: Move all Phone and Email to a Global Object Parsing ( )
    var googleNumber = "tel:+18002288379";
    var emailAddress = "info@1800battery.com";
    var geolocation = props.geolocation;
    if (masterProvider && masterProvider.isActive) {
        phoneNumber = masterProvider.phoneNumber ? masterProvider.phoneNumber : "";
        emailAddress = masterProvider.emailAddress ? masterProvider.emailAddress : "";
    }
    googleNumber = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_11__/* .findPhoneNumbersInText */ .t)(phoneNumber, "US");
    if (googleNumber.length > 0) {
        googleNumber = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_12__/* .parsePhoneNumber */ .S)(googleNumber[0].number.number);
        phoneNumber = googleNumber.formatNational();
        googleNumber = googleNumber.getURI();
    }
    var keywords = [];
    keywords.push((props.category ? props.category.name : "Vehicle") + " Battery");
    keywords.push(geolocation ? geolocation.formatted_address : "Your City");
    keywords.push("Same Day Delivery");
    keywords.push("Professional Installation");
    keywords.push("National Warranty");
    keywords.push("Near Me");
    var hostname = "1800battery.com";
    if (true) {
        hostname = window.location.hostname;
    }
    var url = "vehicle-batteries-car-or-truck";
    var isManual = false;
    var myHref = isManual ? "/".concat(url) : "/category/vehicle-batteries-car-or-truck";
    var asVar = isManual ? url : "/category/".concat(url);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (props.masterProvider) {
            setMasterProvider(props.masterProvider);
            setShowReviews(true);
        } else {
            if (window.localStorage === "undefined") {
                var mp = window.localStorage.getItem("masterprovider");
                if (mp) {
                    var mpParsed = JSON.parse(mp);
                    setMasterProvider(mpParsed);
                    setShowReviews(true);
                }
            }
        }
    }, [
        props
    ]);
    var allCategories = props.allCategories, brands = props.brands, reviews = props.reviews;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_6__/* .NextSeo */ .PB, {
                title: "The Largest Battery Marketplace in North America | 1-800-Battery",
                description: "Roadside and onsite battery assistance services, combined with a nationwide support system for warranty and support.",
                canonical: "https://1800battery.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VideoModalCommercial, {
                open: showModalCommercial,
                onCloseModal: function() {
                    return setShowModalCommercial(false);
                }
            }),
            allCategories && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HomeCategories, {
                categories: (allCategories === null || allCategories === void 0 ? void 0 : allCategories.filter(function(category) {
                    return category.showOnHomePage;
                })) || [],
                allCategoriesCollection: allCategories,
                masterProvider: masterProvider
            }),
            !masterProvider.isActive && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "!p-5 md:!p-10",
                    id: "services",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_city_sections_WhyFeatures__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        title: "Why Choose Us"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "commercial",
                    style: {
                        background: "url(".concat(_src_static_images_landing_blurred_background_jpg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src, ") center center")
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "inner",
                        onClick: function() {
                            return setShowModalCommercial(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "tv",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "icon-container",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fas fa-play-circle"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: _src_static_images_landing_commercial_jpg__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                                        alt: "commercial"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Watch our commercial"
                            })
                        ]
                    })
                })
            }),
            showReviews && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "!mt-4",
                style: {
                    backgroundImage: "url(/images/happy-clients.jpg)",
                    backgroundSize: "700px auto",
                    backgroundPosition: "top right",
                    backgroundRepeat: "no-repeat"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container bg-white/80 lg:bg-transparent",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_category_Reviews__WEBPACK_IMPORTED_MODULE_1__["default"], {
                        href: myHref,
                        type: "static-v2"
                    })
                })
            }),
            brands && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BrandsSection, {
                brandList: brands,
                masterProvider: masterProvider
            }),
            !masterProvider.isActive && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "klaviyo-form-VG2KPf"
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (HomePage);


/***/ }),

/***/ 65727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ category_WhyBulletPoints; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/static/images/icon/landing/fitment.svg
/* harmony default export */ var fitment = ({"src":"/_next/static/media/fitment.b7b7aced.svg","height":640,"width":640});
;// CONCATENATED MODULE: ./src/static/images/icon/landing/free-shipping.svg
/* harmony default export */ var free_shipping = ({"src":"/_next/static/media/free-shipping.573543fb.svg","height":640,"width":640});
;// CONCATENATED MODULE: ./src/static/images/icon/landing/jumpstart.svg
/* harmony default export */ var jumpstart = ({"src":"/_next/static/media/jumpstart.0ac6e70c.svg","height":512,"width":512});
;// CONCATENATED MODULE: ./src/static/images/icon/landing/special-online-prices.svg
/* harmony default export */ var special_online_prices = ({"src":"/_next/static/media/special-online-prices.799b8e85.svg","height":512,"width":512});
;// CONCATENATED MODULE: ./src/static/images/icon/landing/warranty.svg
/* harmony default export */ var warranty = ({"src":"/_next/static/media/warranty.9b3e2934.svg","height":512,"width":512});
;// CONCATENATED MODULE: ./src/components/category/WhyBulletPoints/index.js








var WhyBulletPoints = function(props) {
    var title = props.title, masterProvider = props.masterProvider;
    if (masterProvider && masterProvider.isActive == true) {
        return "";
    }
    var titleMastHead = title ? title : "Why Choose Us";
    var priceMessage = "Cheaper then any Dealership";
    if (titleMastHead == "Jumpstart Upgrade") {
        priceMessage = "Batteries over 2 years old and require a jumpstart need a battery over 40% of the time.  Save Now!";
    }
    return props.isVertical ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "why-1800-battery v2 vertical",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Why Choose 1800Battery"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "item",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas fa-check-circle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: priceMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "item",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas fa-check-circle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: "Installation is included in Price"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "item",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas fa-check-circle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: "Home of the JumpStart Guarantee"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "item",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fas fa-check-circle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: "Correct Battery Guaranteed*"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "*"
                    }),
                    " - Additional Fees May Apply"
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "why-1800-battery v2 ".concat(props.isVertical ? "vertical" : ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: titleMastHead
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "icon-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        objectFit: "contain",
                                        width: "64px",
                                        height: "64px",
                                        src: special_online_prices,
                                        alt: "Special Online Only Prices"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: priceMessage
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "icon-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        objectFit: "contain",
                                        width: "64px",
                                        height: "64px",
                                        src: warranty,
                                        alt: "Warranty"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: "National Warranty Support"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "icon-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        objectFit: "contain",
                                        width: "64px",
                                        height: "64px",
                                        src: free_shipping,
                                        alt: "Free Shipping"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: "Installation is included in Price"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "icon-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        objectFit: "contain",
                                        width: "64px",
                                        height: "64px",
                                        src: jumpstart,
                                        alt: "JumpStart Guarantee"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: "For Mobile Delivery of Car Batteries - Home of the “JumpStart Guarantee“"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "icon-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        objectFit: "contain",
                                        width: "64px",
                                        height: "64px",
                                        src: fitment,
                                        alt: "Fitment Guarantee"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    children: "Correct Battery Guaranteed* - We will make sure its the right battery!"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                className: "text-center mt-3",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fad fa-info-circle"
                    }),
                    " Additional fees may apply"
                ]
            })
        ]
    });
};
/* harmony default export */ var category_WhyBulletPoints = (WhyBulletPoints);


/***/ }),

/***/ 19103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var features = [
    {
        name: "Professional installation included in price",
        description: "No Hidden Charges!",
        iconSrc: "/images/why-us/professional-installation.svg"
    },
    {
        name: "Fitment guaranteed",
        description: "Buy with confidence knowing that your new car battery will fit perfectly",
        iconSrc: "/images/why-us/fitment.svg"
    },
    {
        name: "We come to you",
        description: "Whether you're on the road or relaxing at home, we bring our services directly to you, ensuring hassle-free battery replacements.",
        iconSrc: "/images/why-us/we-come-to-you.svg"
    },
    {
        name: "Geolocation for fast and efficient service",
        description: "Through the geolocation-based operations, we automatically locate the nearest shop and assign an available technician to handle your battery replacement.",
        iconSrc: "/images/why-us/geolocation.svg"
    },
    {
        name: "Make an appointment",
        description: "You have the flexibility to choose the appointment time that aligns with your schedule and the location that is most convenient for you.",
        iconSrc: "/images/why-us/make-an-appoitment.svg"
    },
    {
        name: "Track your order in real time",
        description: "Track the progress of your order, including the real-time location of our technician and an accurate ETA.",
        iconSrc: "/images/why-us/track-your-delivery.svg"
    },
    {
        name: "Buy now, pay over time",
        description: "Make your purchase now and spread out the payments over a period of time. Powered by Affirm.",
        iconSrc: "/images/why-us/affirm.svg"
    },
    {
        name: "Customer approved",
        description: "Our customers say Excellent based on 4000+ reviews",
        iconSrc: "/images/why-us/customer-approved.svg"
    }, 
];
var WhyFeatures = function(param) {
    var title = param.title, hideDescription = param.hideDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "mt-2 text-2xl font-semibold tracking-tight text-gray-800 sm:text-4xl",
                children: title
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-2xl",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mt-2 text-2xl font-semibold tracking-tight text-gray-800 sm:text-3xl",
                        children: "We are the largest Battery Marketplace in North America. Over 10,000 products, 250,000 locations, and 1,000,000 needs served."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-xl !mt-4",
                        children: "From Cars to Coin Cells we have everything available."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mx-auto mt-16 sm:mt-20 lg:mt-24",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dl", {
                    className: "grid grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16",
                    children: features.map(function(feature) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative pl-16",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("dt", {
                                    className: "text-base font-semibold leading-7 text-gray-900",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                src: feature.iconSrc,
                                                width: 64,
                                                height: 64,
                                                alt: feature.name
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-xl",
                                            children: feature.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("dd", {
                                    className: "mt-2 text-base leading-7 text-gray-700",
                                    children: feature.description
                                })
                            ]
                        }, feature.name);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WhyFeatures);


/***/ }),

/***/ 2277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rU": function() { return /* reexport */ utils_link; },
  "xf": function() { return /* reexport */ CategoryUrl; },
  "AK": function() { return /* reexport */ ClassNames; },
  "vn": function() { return /* reexport */ HtmlToReact; },
  "gI": function() { return /* reexport */ Markdownify; },
  "o2": function() { return /* reexport */ PostUrl; },
  "JF": function() { return /* reexport */ SafePrefix; }
});

// UNUSED EXPORTS: withPrefix

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/utils/classNames.js


// TODO: why do we need this? (V.T. 20.12.2021)
function ClassNames() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _classNames;
    return (_classNames = (classnames_default())).call.apply(_classNames, [
        this
    ].concat((0,_to_consumable_array/* default */.Z)(args))) || null;
}

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
;// CONCATENATED MODULE: ./src/utils/htmlToReact.js


// TODO: why do we need this? (V.T. 20.12.2021)
function HtmlToReact(html) {
    if (!html) {
        return null;
    }
    return (0,lib/* default */.ZP)(html, {
        transform: function(node) {
            if (node.type === "script") {
                if (!isEmpty_default()(node.children)) {
                    return "";
                } else {
                    return "";
                }
            }
        }
    });
}

// EXTERNAL MODULE: ./node_modules/marked/lib/marked.esm.js
var marked_esm = __webpack_require__(87441);
;// CONCATENATED MODULE: ./src/utils/markdownify.js


function Markdownify(markdown) {
    if (!markdown) {
        return null;
    }
    return HtmlToReact(marked_esm/* marked.parse */.TU.parse(markdown));
}

// EXTERNAL MODULE: ./node_modules/lodash/startsWith.js
var startsWith = __webpack_require__(10240);
var startsWith_default = /*#__PURE__*/__webpack_require__.n(startsWith);
;// CONCATENATED MODULE: ./src/utils/safePrefix.js

var withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
function SafePrefix(url) {
    if (startsWith_default()(url, "#") || startsWith_default()(url, "http")) {
        return url;
    }
    return withPrefix(url);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/utils/link.js






var Link = function(_param) {
    var children = _param.children, href = _param.href, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "href"
    ]);
    // Pass Any internal link to Next.js Link, for anything else, use <a> tag
    var internal = /^\/(?!\/)/.test(href);
    // For root page, use index.js, for rest use [...slug].js
    var page = href === "/" ? "/" : "/[...slug]";
    var slug = href.split("/");
    if (slug.length > 2) {
        if (slug[1] == "category") {
            page = "/category/[categoryid]?categoryid=".concat(slug[2]);
        }
        if (slug[1] == "product") {
            page = "/product/[productid]?productid=".concat(slug[2]);
        }
    }
    if (internal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: page,
            as: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
                children: children
            }))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        href: href
    }, other), {
        children: children
    }));
};
/* harmony default export */ var utils_link = (Link);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/trim.js
var trim = __webpack_require__(92742);
var trim_default = /*#__PURE__*/__webpack_require__.n(trim);
;// CONCATENATED MODULE: ./src/utils/postUrl.js


var postUrl_withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
function PostUrl(post) {
    var slug = trim_default()(get_default()(post, "slug"), "/");
    return postUrl_withPrefix("/blog/".concat(slug));
}

;// CONCATENATED MODULE: ./src/utils/categoryUrl.js


var categoryUrl_withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
// TODO: Generalize function and reuse (V.T. 31.1.2022)
function CategoryUrl(category) {
    var slug = trim_default()(get_default()(category, "slug"), "/");
    return categoryUrl_withPrefix("/blog/category/".concat(slug));
}

// EXTERNAL MODULE: ./src/utils/withPrefix.js
var utils_withPrefix = __webpack_require__(15629);
;// CONCATENATED MODULE: ./src/utils/index.js










/***/ }),

/***/ 15629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WithPrefix; }
/* harmony export */ });
/* harmony import */ var lodash_trimStart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98392);
/* harmony import */ var lodash_trimStart__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_trimStart__WEBPACK_IMPORTED_MODULE_0__);

function WithPrefix(url) {
    var basePath = "";
    return basePath + "/" + lodash_trimStart__WEBPACK_IMPORTED_MODULE_0___default()(url, "/");
}


/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,5675,1175,529,7204,8013,7708,1874,9774,2888,179], function() { return __webpack_exec__(45728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);